import React from 'react';

interface FinancialEditReasonFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * Required "reason for change" input shared by the booking rate and payment
 * correction modals. The reason is stored in the booking activity log and
 * included in the audit email.
 */
export const FinancialEditReasonField: React.FC<
  FinancialEditReasonFieldProps
> = ({ id, value, onChange }) => (
  <div>
    <label
      htmlFor={id}
      className="mb-1 block text-xs font-medium text-gray-700"
    >
      Reason for change *
    </label>
    <textarea
      id={id}
      rows={2}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g. Rate entered incorrectly at booking"
      className="w-full resize-none rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pos-primary/30"
      required
    />
    <p className="mt-1 text-[11px] leading-snug text-amber-700">
      This change will be recorded in the booking activity and emailed to
      everyone who receives accommodation booking notifications.
    </p>
  </div>
);
